import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagsGridComponent } from './tags-grid.component';
import {TabModule} from '../../tab/tab.module';
import {DxButtonModule, DxDataGridModule, DxPopoverModule} from 'devextreme-angular';
import {GridDefaultModule, GridTitleModule, TagAttributesEditorModule, BadgeModule} from 'shared';
import {UserDomainsChooserModule} from '../../user-domains/user-domains-chooser/user-domains-chooser.module';


@NgModule({
  declarations: [TagsGridComponent],
  imports: [
    CommonModule,
    TabModule,
    DxDataGridModule,
    GridDefaultModule,
    GridTitleModule,
    UserDomainsChooserModule,
    TagAttributesEditorModule,
    DxButtonModule,
    BadgeModule,
    DxPopoverModule,
  ],
  exports: [TagsGridComponent]
})
export class TagsGridModule { }
